import * as React from "react";
import { useState } from "react";
import { useDropzone } from "react-dropzone";
import Button from "@mui/material/Button";
import useDownloader from "react-use-downloader";

import downloadTemplate from "../../../../../styles/svg/download-attachment.svg";
import uploadCloudImg from "../../../../../styles/svg/uploadCloudCSV.svg";
import ImportCardFromCSV from "../importCardsfromCSV/ImportCardFromCSV";
import "./UploadCSV.scss";
import Papa from "papaparse";
import { getAPIBaseUrl } from "../../../../../utils/constants";
import FormDialog from "../../../../../components/Dialog/FormDialog";
import { CustomButton } from "../../../../../components/Button/Button";
import { Link } from "@mui/material";

export default function UploadCSV({ openCSV, closeCSV }) {
  const [openImportCard, setOpenImportCard] = useState(false);
  const [validatedData, setValidatedData] = useState(null); // State to store validated data
  const [checkError, setCheckError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const getUrl = getAPIBaseUrl();
  const { download } = useDownloader();

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: ".csv",
    onDrop: (acceptedFiles) => {
      handleCSV(acceptedFiles);
    },
  });

  const handleCSV = (files) => {
    const file = files[0];

    if (file) {
      Papa.parse(file, {
        header: true, // Treat the first row as headers
        skipEmptyLines: true, // Skip empty lines
        complete: function (results) {
          if (!results.data || results.data.length === 0) {
            console.error("No data found in the CSV file.");
            alert("The CSV file is empty or contains no valid data.");
            return; // Exit the function early
          }
          // Handle parsed results here

          const headers = Object.keys(results.data[0]);
          parseCSV(headers, results.data);
        },
        error: function (error) {
          console.error("Error reading CSV:", error);
        },
      });
    } else {
      alert("Please upload a CSV file.");
    }
  };

  const parseCSV = (headers, csvText) => {
    const isValid = validateCSVData(headers);

    if (isValid) {
      setErrorMessage("");
      setCheckError(false);
      setValidatedData(csvText);
      setOpenImportCard(true);
    }
  };

  const validateCSVData = (headers) => {
    const expectedColumns = ["title", "description", "allocated_hours"];

    if (headers.join(",") !== expectedColumns.join(",")) {
      setErrorMessage("CSV header does not match expected format.");
      console.error("CSV header does not match expected format.");
      return false;
    }

    const missingColumns = expectedColumns.filter(
      (column) => !headers.includes(column)
    );
    if (missingColumns.length > 0) {
      setErrorMessage(`Missing columns: ${missingColumns.join(", ")}`);
      console.error(`Missing columns: ${missingColumns.join(", ")}`);
      return false;
    }
    return true;
  };
  const handleTamplateDownload = (e) => {
    download(`${getUrl}/tenants/card_template.csv`, "card_template.csv");
  };

  const handleClose = () => {
    closeCSV(false);
  };

  return (
    <React.Fragment>
      {openImportCard && (
        <ImportCardFromCSV
          openImportCard={openImportCard}
          closeImportCard={setOpenImportCard}
          closeCSV={closeCSV}
          data={validatedData}
        />
      )}
      <FormDialog
        open={openCSV}
        handleClose={handleClose}
        title={"Upload File"}
        fullWidth={true}
        width={749}>
        <div>
          {errorMessage && (
            <div className="invalidCSVError">{errorMessage}</div>
          )}

          <div
            className={`uploadCSV-box ${isDragActive ? "drag-active" : ""}`}
            {...getRootProps()}>
            <input {...getInputProps()} />
            <img src={uploadCloudImg} alt="Upload Cloud" />
            <div className="p-1">Select a File and drag and drop here</div>
            <div className="p-2">We Support CSV file here</div>
            <CustomButton className="select-file-btn">
              <input
                type="file"
                hidden
                accept=".csv"
                onChange={(e) => handleCSV(e.target.files)}
              />
              SELECT FILE
            </CustomButton>
          </div>

          <div className="mt-4 d-flex justify-content-end">
            <img src={downloadTemplate} alt="" className="mr-2" />
            <Link
              component="button"
              variant="body2"
              onClick={(e) => handleTamplateDownload(e)}>
              Download Template
            </Link>
          </div>
        </div>
      </FormDialog>
    </React.Fragment>
  );
}
